import { Component, OnInit, ElementRef } from '@angular/core';
import { CategoryInspirationResource } from 'app/models/CategoryInspirationResource';
import { forkJoin } from 'rxjs';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { Validators, FormBuilder } from '@angular/forms';
import { UtilsService } from 'app/services/utils.service';
import { CategoryInspirationListResource } from 'app/models/CategoryInspirationListResource';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { BlogResource } from 'app/models/BlogResource';
import { KioskListResource } from 'app/models/KioskListResource';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { KioskResource } from 'app/models/KioskResource';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { BlogAndKioskResource } from 'app/models/BlogAndKioskResource';

@Component({
  selector: 'vbn-edit-news-intranet',
  templateUrl: './edit-news-intranet.component.html',
  styleUrls: ['./edit-news-intranet.component.scss']
})
export class EditNewsIntranetComponent implements OnInit {

  selected_language: string;
  news: BlogResource;
  saveErrors: boolean = false;
  errorMessage: any;
  addressParams: any;
  newsRid: any;
  //categories: CategoryInspirationListResource;
  categoryErr: boolean = false;
  userEmail: string;
  kiosksList: KioskListResource;
	filterCriteria: FilterCriteriaListEdt;
	checkList: any;
	checkObject: any;
	kioskListResource: KioskResource[];
	arrayToSend: any;
  
  constructor(
    private fb: FormBuilder,
    private service: UtilsService,
    private element: ElementRef,
    private _notificationService: NotificationsService,
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
      this.selected_language = "ro";
      this.news = new BlogResource();
      this.news.categories = new Array<CategoryInspirationResource>();
      //this.categories = new CategoryInspirationListResource();
      this.kiosksList = new KioskListResource();
		this.kiosksList.list = new Array<KioskResource>();
		this.filterCriteria = new FilterCriteriaListEdt();
		this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
		this.checkList = new Array();
		this.kioskListResource = new Array();
		this.arrayToSend = new Array();
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getKioskList();
    if(this.router.url != '/add-news') {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.addressParams = JSON.parse(atob(params['json']));
        this.newsRid = this.addressParams.newsRid;
      });
      this.getNewsByRid(this.newsRid);
    }
    //this.getCategoriesList();
  }


	getKioskList() {
		this.service.add('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
			.subscribe(
				response => {
					this.kiosksList = response;
					if (this.kiosksList.errorCode == 1002) {
						forkJoin(
							[this.translate.get('Error'),
							this.translate.get('0 items found after the search!')]
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						});
						this.kiosksList = new KioskListResource();
						this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
						this.kiosksList.list = [];	
					}
					this.initializationKioskList();
				},
				error => this.errorMessage = <any>error);
	}

	initializationKioskList() {
		if (this.kiosksList.list == null) {
			this.kioskListResource = []
		} else {
			this.kioskListResource = this.kiosksList.list;
		}
		this.checkList = new Array();
		for (let i = 0; i < this.kiosksList.list.length; i++) {
			this.checkObject = {};
			this.checkObject.kiosk = new BlogAndKioskResource();
			this.checkObject.kiosk = this.kiosksList.list[i];
			this.checkList.push(this.checkObject);
		}
		this.checkObject = {};
	}

	updateCheckedOptionsKiosk(kiosk, event) {
		if (event.target.checked) {
			let termsOrGdpr = new BlogAndKioskResource()
			termsOrGdpr.kiosk = kiosk;
			this.arrayToSend.push(termsOrGdpr);
		} else {
			for (let i = 0; i < this.arrayToSend.length; i++) {
				if (kiosk.rid == this.arrayToSend[i].kiosk.rid) {
					this.arrayToSend.splice(i, 1);
					return
				}
			}
		}
	}

  validationForm = this.fb.group({
    titleRo: ['', [Validators.required, this.service.NoWhitespaceValidator()]],
    titleEn: [''],
    titleFr: [''],
    titleDe: [''],
    shortDescRo: ['', [Validators.required, this.service.NoWhitespaceValidator()]],
    shortDescEn: [''],
    shortDescFr: [''],
    shortDescDe: [''],
    descriptionRo: ['', [Validators.required, this.service.NoWhitespaceValidator()]],
    descriptionEn: [''],
    descriptionFr: [''],
    descriptionDe: [''],
    tagRo:[''],
    tagEn:[''],
    tagFr:[''],
    tagDe:['']
  })

  changeListenerMainImage($event): void {
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var image = this.element.nativeElement.querySelector('#documentInput');
    if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
      (file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
      (file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
      (file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
      if (file.size < 1000000) {
        myReader.onloadend = (e: any) => {
          image.src = e.target.result;
          this.news.imageString = e.target.result;
        }
        myReader.readAsDataURL(file);
      } else {
        forkJoin(
          this.translate.get('Image error'),
          this.translate.get('Image size is more than 1 mb!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    } else {
      forkJoin(
        this.translate.get('Image error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
  }

  edit() {
    this.saveErrors = true
    let errors = false;
    if (!this.validationForm.valid) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields on all languages!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    } 
    if (this.arrayToSend.length == 0) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please check at least 1 kiosk!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    }
   /*  if(this.news.categories.length == 0){
			this.categoryErr = true;
			errors = true;
		}else {
			this.categoryErr = false;
		} */
		if(errors){
			return
    }
    this.news.kioskResourceList = this.arrayToSend;
    this.service.add(`/admin/newsCategory/editBlog?userEmail=${this.userEmail}`, this.news)
      .subscribe(
        response => {
          this.news = response;
          if(this.newsRid) {
            forkJoin(
              this.translate.get('Success'),
              this.translate.get('News successfully edited!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            });
          } else {
            forkJoin(
              this.translate.get('Success'),
              this.translate.get('News successfully created!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            });
          }
          window.scrollTo(500, 0);
          this.router.navigate(['/news-list']);
        },
        error => this.errorMessage = <any>error);
  }

  // checkGenre(genre: CategoryInspirationResource){
  //   if(this.news.categories) {
  //     for(let i = 0; i < this.news.categories.length; i++){
  //       if(genre.rid == this.news.categories[i].rid){
  //         if(this.categoryErr){
  //           this.categoryErr = false
  //         }
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // }

  // updateCheckedOptions(genre : CategoryInspirationResource, event) {
  //   if(event.target.checked){
  //     this.news.categories.push(genre);
  //   } else {
  //     for(let i = 0; i < this.news.categories.length; i++){
  //       if(genre.rid == this.news.categories[i].rid){
  //         this.news.categories.splice(i,1);
  //         return
  //       }
  //     }
  //   }
  //   console.log("eveniment : {}, locatie : {}",event.target.checked, genre);
  // }

  getNewsByRid(rid) {
    this.service.get('/admin/newsCategory/getBlog/' + rid+"?userEmail="+this.userEmail)
      .subscribe(
        response => {
          this.news = response;
          Object.assign(this.kioskListResource, this.kiosksList)
						for (let i = 0; i < this.kioskListResource.length; i++) {
							for(let j = 0; j < this.news.kioskResourceList.length; j++) {
								if(this.news.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
									for(let k = 0; k < this.checkList.length; k++) {
										if(this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
											this.checkList[k].check = true;
											this.arrayToSend.push(this.checkList[k]);
										}
									}
								}
							}
						}
        },
        error => this.errorMessage = <any>error);
  }

  showResponsiveDetails(kioskId) {
		const width = window.innerWidth;
		if (width <= 1100) {
			for (let i = 0; i < this.kiosksList.list.length; i++) {
				if (this.kiosksList.list[i].rid == kioskId) {
					this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
				}
				else {
					this.kiosksList.list[i].showDetailsOnResponsive = false;
				}
			}
		}
		else{
			return;
		}

	}

  /* getCategoriesList() {
    this.service.get('/admin/newsCategory/getAllCategories')
      .subscribe(
        response => {
         this.categories = response;
        },
        error => this.errorMessage = <any>error);
  } */
}
